<template>
  <div class="Singo">
    <!-- s: header -->
    <header id="header-slidePanel">
      <h2>신고하기</h2>
      <div class="btn_back">
        <a @click="slidePanelClose"><img src="@/assets/images/btn_close.png" width="50" alt="이전"/></a>
      </div>
    </header>
    <!-- e: header -->
    <div class="contents-area-slidePanel">
      <div class="title-area">
        <div class="label-text">제목</div>
        <div class="label-content"><strong>{{ boardDetail.oBoard.strBoardTitle }}</strong></div>
      </div>
      <div class="title-area">
        <div class="label-text">작성자</div>
        <div class="label-content"><strong>{{ boardDetail.oUser.strNickName }}</strong></div>
      </div>
      <div class="note-content">
        <h3 class="slidePanel-sub-title no-pdd-top">신고사유</h3>
        <ul class="li-bottom-line">
          <li v-for="data in boardReport" :key="data.nReportNum">
            <span><label class="rad"><input type="radio" v-model="nReportNum"
                                            :value="data.nReportNum"/><i></i> {{ data.strReportName }}</label></span>
            <div class="form-box mrg-left-25" v-if="data.nReportNum === 0">
              <div class="input-box">
                <div class="input-item"><input type="text" v-model="nReportNumEtc" placeholder=""/></div>
              </div>
            </div>
          </li>
        </ul>
        <div class="info-text mrg-top-20">
          <h5>신고하기 전에 잠깐!</h5>
          <p>신고하기는 마음에 들지 않는 글에 사용하는 기능이 아닙니다.<br/>
            허위 신고나 신고 기능을 오남용하는 경우 이용이 제한될 수 있으니<br/>
            신중하게 신고해주세요. </p>
        </div>
      </div>

      <footer class="flex justify-between ">
        <button class="btn-big btn-white mrg-right-10" @click="slidePanelClose">취소</button>
        <button class="btn-big btn-bule" @click="formSendFunc">신고하기</button>
      </footer>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Singo',
  props: ['pBoardActiveCode', 'pBoardSeq'],
  data() {
    return {
      boardDetail: {
        oBoard: {},              // 게시글 정보
        oMenu: {},               // 메뉴 정보
        oUser: {}                // 사용자 정보
      },
      boardReport: {},             // 신고 리스트 정보
      nReportNum: '',              // 신고 내용
      nReportNumEtc: '',           // 기타
      isSending: false,            // 전송체크
    }
  },
  // 감시자
  watch: {},
  // $el 생성전
  created() {
  },
  // $el 생성후
  mounted() {
    window.callbackBackKey = this.callbackBackKey;
    this.getReportList();
  },
  methods: {
    // APP 뒤로가기
    callbackBackKey() {
      this.slidePanelClose();
    },
    // 신고 항목 리스트
    getReportList() {
      let param = {};
      let boardActiveCode = this.pBoardActiveCode;
      let boardSeq = this.pBoardSeq;
      this.ajaxGetAuth('/api/v1/report/list/' + boardActiveCode + '/' + boardSeq, param, this.getReportListResult);
    },
    // 신고 항목 리스트 결과
    getReportListResult(response) {
      if (response.result.code == 0) {
        this.boardDetail.oBoard = response.oBoardInfo.detail.oBoard;
        this.boardDetail.oMenu = response.oBoardInfo.detail.oMenu;
        this.boardDetail.oUser = response.oBoardInfo.detail.oUser;

        this.boardReport = response.oReportInfo.list;
      } else {
        this.toastMsg(response.result.resultNoti.message, 1500);
      }
    },
    // 게시글, 댓글 신고하기
    formSendFunc() {
      // 더블클릭 방지 체크
      if (this.isSending) {
        return false;
      }

      let boardActiveCode = this.pBoardActiveCode;
      let boardSeq = this.pBoardSeq;

      let formData = new FormData();
      formData.append('nReportNum', this.nReportNum);
      formData.append('strReportMsg', this.nReportNumEtc);

      this.isSending = true;
      this.ajaxPostAuth('/api/v1/report/' + boardActiveCode + '/' + boardSeq, formData, this.formSendFuncResult);
    },
    // 게시글, 댓글 신고하기 결과
    formSendFuncResult(response) {
      this.isSending = false;
      this.toastMsg(response.result.resultNoti.message, 1500);
      if (response.result.code == '4101') {
        this.slidePanelClose();
      }
    },
  }
}
</script>

<style scoped>
.slidePanel-title h2 {
  font-weight: 500;
}

.note-content {
  font-size: 16px;
  padding-top: 15px;
  margin-bottom: 120px;
}

.li-bottom-line li {
  padding: 5px 0;
  border-bottom: none;
}

footer {
  position: fixed !important;
  bottom: 0px;
  left: 0;
  right: 0;
  border-top: 1px solid #dfdfdf;
  padding: 20px 10px;
  background: #fff
}
</style>
